import clsx from 'clsx';

export interface ReadOnlyFieldProps {
  label: string;
  value?: string | null;
  className?: string;
}

/**
 * ReadOnlyField — renders a value as display text rather than a disabled input
 * (ENG-5290 T2 §4c): muted label above a normal-weight value, no border/focus.
 * Used where the §5.5 matrix marks a field group read-only for the viewer/stage.
 */
export function ReadOnlyField({ label, value, className }: ReadOnlyFieldProps): JSX.Element {
  return (
    <div className={clsx('flex flex-col gap-2', className)}>
      <span className="text-on-surface-muted subtitle-2">{label}</span>
      <span className="whitespace-pre-line text-on-surface body-1">{value || '—'}</span>
    </div>
  );
}
